import { PageSeoUpdate } from '@/api/dashboard'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { useParams } from 'react-router-dom'
import { NullablePartial } from '@/libs'

interface PageSeoMutate {
  update: NullablePartial<PageSeoUpdate>
}

export const usePageSeoMutate = (pageId: string) => {
  const { companyId, gameId } = useParams() as { companyId: string; gameId: string }
  const queryClient = useQueryClient()

  return useMutation({
    // @ts-ignore
    mutationFn: ({ update }: PageSeoMutate) => dashboardClient.v1.updatePageSeo(pageId, companyId, gameId, update),
    onSuccess: async data => {
      queryClient.setQueryData(['pages', gameId, pageId], data.data)
      await queryClient.invalidateQueries({ queryKey: ['pages', gameId, pageId] })
    },
  })
}
